import React from "react";
import { classNames } from "../../shared/utility";
import { InputNumber } from "primereact/inputnumber";

export default function InputNumberOnly(props) {
  const {
    parentClass,
    className,
    label,
    name,
    onChange,
    type,
    value,
    labelOn,
    error,
    suffix,
    explanation,
    ref,
    labelClass,
    ...other
  } = props;

  return (
    <div className={parentClass ? parentClass : null}>
      {labelOn ? (
        <label
          htmlFor={name}
          className={classNames(
            labelClass ? labelClass : "text-sm",
            "block font-medium text-gray-900 mb-2"
          )}
        >
          {label}
        </label>
      ) : null}
      <div>
        <InputNumber
          name={name}
          className={className}
          value={value}
          onValueChange={onChange}
          onKeyDown={(e) => e.stopPropagation()}
          ref={ref}
          suffix={suffix}
          {...other}
        />

        {error ? <p className="font-medium text-red-500">{error}</p> : null}
      </div>
    </div>
  );
}
